"use client";

import { useTranslations } from "use-intl";

import { ArrowForwardIcon, RefreshIcon } from "@/components/appIcons";
import { Link } from "@/components/link";
import { Button } from "@/components/ui/button";
import { useWebPushController } from "@/hooks/use-web-push-controller";

export function BrowserPushFallbackRecovery({
  alerts,
  controller,
}: {
  alerts: boolean;
  controller: ReturnType<typeof useWebPushController>;
}) {
  const t = useTranslations("browserPush");

  return (
    <div className="mt-5 flex flex-wrap items-center gap-3">
      {controller.status === "denied" ? (
        <Button
          className={alerts ? "min-h-11 max-w-full px-4 font-bold" : undefined}
          onClick={controller.refresh}
          size="default"
          variant="outline"
        >
          <RefreshIcon decorative />
          {t("permissionChangedCta")}
        </Button>
      ) : null}
      <Link
        className={
          alerts
            ? "inline-flex min-h-11 items-center gap-1 text-sm font-bold sm:min-h-10 text-[#f4a17f] underline underline-offset-4 hover:text-[#ffc1aa]"
            : "inline-flex min-h-11 items-center gap-1 text-sm font-bold sm:min-h-10 text-primary underline underline-offset-4"
        }
        hash={alerts ? "alerts-telegram" : undefined}
        to="/alerts"
      >
        {t("otherChannelsCta")}
        <ArrowForwardIcon decorative />
      </Link>
    </div>
  );
}
